import React, { useEffect, useState } from "react";
import Product from "../products/Product";
import { isValuePresent } from "../../utils/builderUtils";
import {
  resolveProductsFeedLayout,
  resolveProductsFeedLayoutMobile,
} from "../../utils/productsFeedLayout";
import { buildProductsStylesheet } from "./ElementProductsStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const ElementProducts = (props) => {
  const element = props.element;
  const classes = style.classes(element, props.device);
  const stylesheet = buildProductsStylesheet(
    props.builder,
    props.device,
    props.cta,
    element,
    props.variant
  );

  let productsLimit = element.options["products-limit"] || 3;
  if (element.options["cart-show-all-products"] == "true") {
    productsLimit = 4
  }

  // Standard Products: Also used on live script to correctly render products
  let tmpProductsList = [];
  [...Array(parseInt(productsLimit || 3))].forEach((_, i) => {
    const placeholderLabel = ["Shopify", "ShopifyGraphql"].includes(
      element.options["products-source"]
    )
      ? "Shopify Product"
      : "Placeholder";

    let price = i + 1;
    let discountedPrice;

    if (element.options["products-discount-type"] == "amount") {
      const discountAmount =
        element.options["products-discount-amount"] || 10;

      discountedPrice = (price - discountAmount).toFixed(2);
    }

    if (element.options["products-discount-type"] == "percentage") {
      const discountAmount =
        element.options["products-discount-percentage"] || 10;

      discountedPrice = (
        price -
        price * (parseInt(discountAmount) * 0.01)
      ).toFixed(2);
    }

    if (element.options["products-discount-type"] == "detect") {
      discountedPrice = (price - price * (parseInt(5) * 0.01)).toFixed(2);
    }

    if (discountedPrice && discountedPrice <= 0) {
      discountedPrice = "0.00";
    }

    tmpProductsList.push({
      image: null,
      title: `${placeholderLabel} ${i + 1}`,
      price: price.toFixed(2),
      discounted_price: discountedPrice,
      product_variants: [],
      imageList: [],
      options: [{ id: '1', name: 'Options', values: [1,2,3]}],
    });
  });
  // End Standard Products

  const [productsList, setProductsList] = useState(tmpProductsList);

  const [reviewsList, setReviewsList] = useState([]);

  const loadShopifyGraphqlProducts = (integration, products) => {
    let shopifyProducts = [];
    let orderedProducts = products;

    if (element.options["shopify-products-source"] == "selected" && element.options["shopify-products-selected"]) {
      const parsedLimitedVariantIds = element.options["shopify-products-selected-variants"]?.split(",").filter((item) => item) || []

      shopifyProducts = Object.values(orderedProducts).filter((product) =>
        element.options["shopify-products-selected"]
          .split(",")
          .includes(product.handle)
      );

      shopifyProducts = shopifyProducts.map((product) => {
        return {
          ...product,
          variants: parsedLimitedVariantIds.length > 0 ? product.variants.filter((variant) => parsedLimitedVariantIds.includes(variant.id)) : product.variants
        }
      });

    } else if (element.options["shopify-products-source"] == "filter") {
      const productsFilter = element.options["shopify-products-filter"];

      shopifyProducts = Object.values(orderedProducts).map((el) => {
        if (el.handle.includes(productsFilter) ||
          el.product_type.includes(productsFilter) ||
          el.tags.includes(productsFilter) ||
          el.variants.some(variant => variant.title.includes(productsFilter))
        ) {
          return el
        }
      }).filter(el => el)
    } else if (element.options["shopify-products-source"] == "collection") {
      const collectionIds = element.options["shopify-products-collection"]?.split(",").filter(item => item) || [];
      const showUnavailable = element.options["shopify-products-unavailable"] == "true";

      shopifyProducts = Object.values(products).map((el) => {
        const productAvailable = el.available !== false || showUnavailable == true;

        if (productAvailable && el.collections.some(collection => collectionIds.includes(collection.handle))) {
          return el
        }
      }).filter(el => el)
    } else if (element.options["shopify-products-source"] == "current") {
      let shopifyProductHandles = [element.options["shopify-products-current-fallback"]];

      shopifyProducts = Object.values(products).map((el) => {
        if (shopifyProductHandles.some(handle => el.handle.includes(handle))) {
          return el
        }
      }).filter(el => el)
    }

    // Filter out excluded products (skip if source is "selected" or "current")
    if (element.options["shopify-products-excluded"] && ["selected", "current"].includes(element.options["shopify-products-source"]) == false) {
      const excludedHandles = element.options["shopify-products-excluded"].split(",").map(item => item.trim()).filter(item => item);
      shopifyProducts = shopifyProducts.filter((product) => {
        return !excludedHandles.includes(product.handle);
      });
    }

    if (shopifyProducts.length > 0) {
      let sliced = element.options["shopify-products-source"] !== "selected" ?
        shopifyProducts.slice(0, productsLimit) : shopifyProducts
      setProductsList(sliced);
    } else {
      setProductsList(tmpProductsList)
    }
  };

  const fetchShopifyGraphql = (integration) => {
    if (integration) {
      const parsed_store_name = (
        integration.api_data?.api_url || integration.api_data?.website
      )
        ?.replace("http://", "")
        ?.replace("https://", "")
        ?.replace(".myshopify.com", "")
        ?.replace("/", "")
        ?.replace(" ", "");
      const shopifyClient = new ShopifyGraphqlClient({
        store_name: parsed_store_name,
        token: integration.api_data["storefront-token"],
      });

      let productHandles;

      if (element.options["shopify-products-source"] == "selected" && element.options["shopify-products-selected"]) {
        productHandles = element.options["shopify-products-selected"].split(",");
      } else if (element.options["shopify-products-source"] == "filter" && element.options["shopify-products-source"] && element.options["shopify-products-filter"]) {
        productHandles = element.options["shopify-products-filter"].split(",");
      } else if (element.options["shopify-products-source"] == "collection" && element.options["shopify-products-collection"]) {

        const collectionIds = element.options["shopify-products-collection"]?.split(",").filter(item => item) || [];

        const promises = collectionIds.map(collectionId => {
          return new ProductsAdapterService(shopifyClient, "ShopifyGraphql", true)
            .getCollectionProducts(collectionId, {
              limit: productsLimit, sort: element.options["shopify-products-sorting"]
            });
        });

        Promise.allSettled(promises)
          .then(results => {
            loadShopifyGraphqlProducts(
              integration,
              results
                .filter((result) => result.status == "fulfilled")
                .flatMap((result) => result.value)
            );
          })

      } else if (element.options["shopify-products-source"] == "current" && element.options["shopify-products-current-fallback"]) {
        productHandles = element.options["shopify-products-current-fallback"].split(",");
      }

      if (productHandles && productHandles.length > 0) {
        const productHandlesPromises = productHandles.map((handle) => {
          return new ProductsAdapterService(shopifyClient, "ShopifyGraphql", true)
            .getProduct(handle)
        })

        Promise.allSettled(productHandlesPromises).then((results) => {
          loadShopifyGraphqlProducts(
            integration,
            results
              .filter((result) => result.status == "fulfilled")
              .map((result) => result.value)
          );
        })
      }
    }
  };

  const setupProductsFeed = (ignore_cache = false) => {
    if (props.builder == true) {
      if (element.options["products-source"] == "Shopify") {
        const integration = Object.values(props.website.integrations).filter(
          (i) => i.integration_type == "Shopify" && i.status == true
        )[0];

        if (integration && integration.api_data["products"]) {
          let shopifyProducts = [];
          let tmpProductsList = [];

          if (element.options["shopify-products-source"] == "selected") {
            if (element.options["shopify-products-selected"]) {
              shopifyProducts = Object.values(
                integration.api_data["products"]
              ).filter((product) =>
                element.options["shopify-products-selected"]
                  .split(",")
                  .includes(product["id"] + "")
              );
            }
          }

          if (shopifyProducts.length == 0) {
            shopifyProducts = tmpProductsList
          }

          if (
            !element.options["shopify-products-source"] ||
            ["filter", "related", "cart"].includes(
              element.options["shopify-products-source"]
            )
          ) {
            shopifyProducts = integration.api_data["products"].slice(
              0,
              parseInt(productsLimit)
            );
          }

          shopifyProducts.forEach((shopifyProduct) => {
            const productVariant = integration.api_data[
              "product_variants"
            ].filter(
              (productVariant) =>
                productVariant["product_id"] == shopifyProduct["product_id"]
            )[0];

            if (productVariant) {
              let productVariants;

              if (shopifyProduct.options) {
                productVariants = shopifyProduct.options.map(
                  (productOption) => {
                    return {
                      id: productOption,
                      title: productOption,
                    };
                  }
                );
              }

              let discountedPrice;

              if (element.options["products-discount-type"] == "amount") {
                const discountAmount =
                  element.options["products-discount-amount"] || 10;

                discountedPrice = (
                  productVariant.price - discountAmount
                ).toFixed(2);
              }

              if (element.options["products-discount-type"] == "percentage") {
                const discountAmount =
                  element.options["products-discount-percentage"] || 10;

                discountedPrice = (
                  productVariant.price -
                  productVariant.price * (parseInt(discountAmount) * 0.01)
                ).toFixed(2);
              }

              if (discountedPrice && discountedPrice <= 0) {
                discountedPrice = "0.00";
              }

              tmpProductsList.push({
                title: shopifyProduct.name,
                price: productVariant.price,
                product_variants: productVariants,
                discounted_price: discountedPrice,
              });
            }
          });

          if (tmpProductsList.length > 0) {
            setProductsList(tmpProductsList);
          }
        }
      } else if (element.options["products-source"] == "ShopifyGraphql") {
        let shopifyProducts = window.cf_shopify_products;

        const integration = Object.values(props.website.integrations).filter(
          (i) => i.integration_type == "Shopify" && i.status == true
        )[0];

        if (shopifyProducts && ignore_cache == false) {
          loadShopifyGraphqlProducts(integration, shopifyProducts);
        } else {
          fetchShopifyGraphql(integration);
        }
      } else {
        let products = Object.values(element.products)
          .filter(
            (product) =>
              product.element_id == element.id && product.toBeDeleted !== true
          )
          .sort((a, b) => {
            return a.position - b.position;
          });

        if (products.length == 0) {
          products = tmpProductsList;
        }

        if (props.builder !== true) {
          Object.values(element.product_recommendations).forEach(
            (product_recommendation) => {
              Object.values(product_recommendation.products)
                .sort((a, b) => {
                  return a.position - b.position;
                })
                .forEach((product) => {
                  products.push(product);
                });
            }
          );
        }

        const adapterService = new ProductsAdapterService(
          undefined,
          "Convertflow"
        );

        if (products.length > 0) {
          setProductsList(
            products.map((product) => adapterService.adaptProduct(product))
          );
        }
      }
    }
  }

  useEffect(() => {
    setupProductsFeed();
  }, [
    element.options["shopify-products-related-type"],
    element.options["shopify-products-filter"],
    element.options["shopify-products-collection"],
    element.options["shopify-products-selected"],
    element.options["shopify-products-excluded"],
    element.options["products-source"],
    element.products
  ]);

  useEffect(() => { setupProductsFeed(true) }, [
    element.options["shopify-products-sorting"],
  ]);

  if (props.builder == true) {
    useEffect(() => {
      let productIds = productsList.map(prod => prod.id)

      if (element.options["products-reviews-source"] && productIds.filter(id => id != null).length > 0) {
        const integration = Object.values(props.website.integrations).find(
          (i) =>
            i.integration_type == element.options["products-reviews-source"] &&
            i.status == true
        );

        if (integration) {
          new ReviewsIntegrationsService(integration.integration_type, integration)
            .getReviews(productIds)
            .then((response) => {
              setReviewsList(response);
            });
        } else {
          setReviewsList([]);
        }
      }
    }, [productsList, element.options["products-reviews-source"]]);
  }

  const desktopLayout = resolveProductsFeedLayout(element.options);
  const mobileLayout = resolveProductsFeedLayoutMobile(element.options);
  const layout = resolveProductsFeedLayout(element.options, props.device);

  let productsPerRow;
  if (desktopLayout === "list") {
    productsPerRow = 1;
  } else {
    productsPerRow = element.options["products-limit-row"]
      ? element.options["products-limit-row"]
      : 3;
  }

  const productsPerRowMobile =
    mobileLayout === "list"
      ? 1
      : element.options["products-limit-row-mobile"]
        ? element.options["products-limit-row-mobile"]
        : 1;

  let productAllButton;
  if (
    element.options["products-source"]?.toLowerCase() !== "convertflow" &&
    element.options["products-button-cart-all"] == "true" &&
    element.options["confirmation-type"] == "cart"
  ) {
    let buttonAllText = element.options["products-button-cart-all-text"]
      ? element.options["products-button-cart-all-text"]
      : "<p>Add All To Cart</p>";

    productAllButton = (
      <div
        className="cf-row cf-outer-center cf-products-all-button-outer est"
        data-element-id={element.id}
      >
        <div
          className={classes.buttonAddAllClasses + " cf-merge-tag-allowed"}
          dangerouslySetInnerHTML={{
            __html:
              props.builder == true
                ? "<div class='froala-editor'>" + buttonAllText + "</div>"
                : buttonAllText,
          }}
        ></div>
      </div>
    );
  }

  const emptyMessage = element.options["products-empty-message"]
    ? element.options["products-empty-message"]
    : "<p>Sorry, there are no products to display</p>";

  return (
    <React.Fragment>
      <div
        className="cf-products-outer cf-products-element"
        data-layout={props.builder ? layout : desktopLayout}
        data-layout-mobile={mobileLayout}
        data-products-per-row={productsPerRow}
        data-products-per-row-mobile={productsPerRowMobile}
        data-element-id={element.id}
      >
        {productsList
          .sort((a, b) => {
            return a.position - b.position;
          })
          .map((product, i) => {
            const productReviews = reviewsList.find(
              (review) => review.product_id == product.id
            );

            return (
              <Product
                productReviews={productReviews}
                key={`product-${product.id}-${i}`}
                layout={desktopLayout}
                product={product}
                classes={classes}
                {...props}
              />
            );
          })}
      </div>
      {productAllButton}
      <div
        className="cf-row cf-outer-center cf-products-empty-message cf-merge-tag-allowed"
        data-layout={props.builder ? layout : desktopLayout}
        data-layout-mobile={mobileLayout}
        dangerouslySetInnerHTML={{ __html: emptyMessage }}
        data-element-id={element.id}
      />
      <BuilderStyleTag
        builder={props.builder}
        styleKey={`cta:${props.cta.id}:element:${element.id}:products`}
        stylesheet={stylesheet}
      />
    </React.Fragment>
  );
};

const style = {
  classes: (element, device) => {
    let options = element.options;

    let baseButtonClasses =
      "element-content cf-button cf-button-primary cf-text-element";

    let buttonClasses = baseButtonClasses +
      " " +
      (options["button-size"] ? options["button-size"] : "cf-button-small");

    let buttonAddAllClasses =
      baseButtonClasses +
      `${
        options["products-add-all-btn-padding"]
          ? " " + options["products-add-all-btn-padding"]
          : " cf-button-small"
      }`;

    let buttonLayoutClasses =
      options["button-width"] && options["button-width"] !== "custom"
        ? options["button-width"]
        : !options["button-width"]
        ? "cf-full-width"
        : options["button-width"] == "custom"
        ? ""
        : "cf-full-width";

    let buttonAddAllWidthClass;
    if (options["products-add-all-btn-width"] && options["products-add-all-btn-width"] !== "custom") {
      buttonAddAllWidthClass = options["products-add-all-btn-width"];
    }

    if (device == "mobile") {
      if (options["products-add-all-btn-width-mobile"] && options["products-add-all-btn-width-mobile"] !== "custom") {
        buttonAddAllWidthClass = options["products-add-all-btn-width-mobile"];
      }
    }
    buttonAddAllClasses += " " + buttonAddAllWidthClass;

    buttonLayoutClasses +=
      " " +
      (resolveProductsFeedLayout(options) !== "list" &&
      options["button-alignment"]
        ? options["button-alignment"]
        : "");

    return {
      buttonClasses: buttonClasses,
      buttonAddAllClasses: buttonAddAllClasses,
      buttonLayoutClasses: buttonLayoutClasses,
    };
  },
};

export default ElementProducts;
